import { Link } from "react-router-dom";
import { Layers } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t, language } = useLanguage();

  return (
    <footer className="py-12 px-4 bg-slate-900 text-slate-400">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center">
                <Layers className="w-4 h-4 text-white" />
              </div>
              <h4 className="text-white font-semibold">Epidemos</h4>
            </div>
            <p className="text-sm">{t("footer.desc")}</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t("footer.product")}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/funkcje" className="hover:text-white transition-colors">
                  {t("footer.features")}
                </Link>
              </li>
              <li>
                <Link to="/shop-public" className="hover:text-white transition-colors">
                  {t("footer.shop")}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white transition-colors">
                  {t("footer.blog")}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t("footer.company")}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  {t("footer.about")}
                </a>
              </li>
              <li>
                <a href="mailto:bok@epidemos.pl" className="hover:text-white transition-colors">
                  {t("footer.contact")}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t("footer.legal")}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/regulamin" className="hover:text-white transition-colors">
                  {t("footer.terms")}
                </Link>
              </li>
              <li>
                <Link to="/polityka-prywatnosci" className="hover:text-white transition-colors">
                  {t("footer.privacy")}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Dla wydawców</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/api-docs" className="hover:text-white transition-colors">
                  Dokumentacja API
                </Link>
              </li>
              <li>
                <Link to="/wydawcy-testy" className="hover:text-white transition-colors">
                  Sandbox testowy
                </Link>
              </li>
              <li>
                <a href="/api/v1/publisher-api-v2.md" target="_blank" rel="noopener"
                   className="hover:text-white transition-colors">
                  Spec v2 (markdown)
                </a>
              </li>
              <li>
                <a href="/api/v1/emergent-blog-standard" target="_blank" rel="noopener"
                   className="hover:text-white transition-colors text-slate-500">
                  Spec v1 (legacy)
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row items-center justify-between text-sm gap-4">
          <p>&copy; 2026 Epidemos. {t("footer.rights")}</p>
          <div className="flex gap-4 items-center flex-wrap justify-center">
            <Link to="/regulamin" className="hover:text-white transition-colors">
              {t("footer.terms")}
            </Link>
            <Link to="/polityka-prywatnosci" className="hover:text-white transition-colors">
              {t("footer.privacy")}
            </Link>
            <span className="text-slate-600">|</span>
            <span>
              {language === 'pl' ? 'Wykonawca' : 'Developer'}{" "}
              <a
                href="https://www.zens.pl/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 font-medium"
              >
                IT Zens
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
